/* Product Locator: store finder for recent Fire Bros. shipments. Reads the CSV from Shopify Files and renders it client-side. */
(function(){
"use strict";
function init(root, csvText, ZIPS){

const TAXONOMY = [
  ["Vapes", ["AIOs","510 Tankers","Pearls","Peli-Case AIO"]],
  ["Concentrates", ["Gold Tier Oil","Silver Tier Oil","CBDabs"]],
  ["Pre-Roll", ["2-Packs","Single Strain 5-packs","Variety Packs"]],
  ["Infused Pre-Rolls", ["Blunts","Forte"]],
  ["Flower", ["1g","3.5g","7g","14g","28g"]],
];
const CATS = TAXONOMY.map(t=>t[0]);
const SUBS = Object.fromEntries(TAXONOMY);
const key = (c,s) => c+" › "+s;
const MAX_WINDOW = 14, PAGE = 24;

const DAY = 864e5;
const today = new Date(); today.setHours(0,0,0,0);
const $ = name => root.querySelector('[data-fd="'+name+'"]');
const esc = s => String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const daysAgo = d => Math.round((today - new Date(d+"T00:00:00"))/DAY);
const fmtDate = (d,opt) => new Date(d+"T00:00:00").toLocaleDateString(undefined,opt||{weekday:"short",month:"short",day:"numeric"});

function parseCSV(text){
  const out=[]; let row=[], cell="", q=false;
  for(let i=0;i<text.length;i++){
    const c=text[i];
    if(q){ if(c==='"'){ if(text[i+1]==='"'){cell+='"';i++;} else q=false; } else cell+=c; }
    else if(c==='"') q=true;
    else if(c===","){ row.push(cell); cell=""; }
    else if(c==="\n"||c==="\r"){ if(c==="\r"&&text[i+1]==="\n") i++; row.push(cell); out.push(row); row=[]; cell=""; }
    else cell+=c;
  }
  if(cell!==""||row.length){ row.push(cell); out.push(row); }
  return out.filter(r=>r.some(v=>v.trim()!==""));
}

/* Rows: store, license, address, city, zip, phone, website, shipped, ordered, category, subcategory, strain */
const table = parseCSV(String(csvText||"").trim());
if(table.length<2) throw new Error("empty");
const H = table[0];
const rows = table.slice(1).map(r=>Object.fromEntries(H.map((h,i)=>[h,(r[i]||"").trim()])))
  .filter(r=>SUBS[r.category] && SUBS[r.category].includes(r.subcategory));
const latest = rows.reduce((m,r)=>r.shipped>m?r.shipped:m,"");

/* One store record per license, with every drop in the window. */
const stores = (()=>{
  const map=new Map();
  rows.forEach(r=>{
    const n=daysAgo(r.shipped); if(n<0||n>MAX_WINDOW) return;
    const k=r.license||r.store.toLowerCase();
    if(!map.has(k)) map.set(k,{store:r.store,address:r.address||"",city:r.city,zip:r.zip||"",phone:r.phone||"",website:r.website||"",lat:parseFloat(r.lat),lng:parseFloat(r.lng),drops:[]});
    map.get(k).drops.push({...r,n});
  });
  return [...map.values()];
})();

const state = { q:"", cats:new Set(), subs:new Set(), days:14, sort:"fresh", shown:PAGE, here:null, radius:+(root.dataset.radius||25) };
function miles(a,b){ const R=3958.8, r=x=>x*Math.PI/180, dLat=r(b.lat-a.lat), dLng=r(b.lng-a.lng);
  const h=Math.sin(dLat/2)**2+Math.cos(r(a.lat))*Math.cos(r(b.lat))*Math.sin(dLng/2)**2; return 2*R*Math.asin(Math.sqrt(h)); }
const fmtMi = d => d<1 ? "under 1 mi" : (d<10 ? d.toFixed(1) : Math.round(d))+" mi";
try{ const saved=JSON.parse(localStorage.getItem("product-locator-filters")||"null"); if(saved){ state.days=saved.days||14; state.sort=saved.sort||"fresh"; } }catch(e){}

/* Drops a store had inside the current time window. */
function view(s){
  const drops=s.drops.filter(d=>d.n<=state.days);
  if(!drops.length) return null;
  return {s, drops, last:Math.min(...drops.map(d=>d.n)),
    cats:new Set(drops.map(d=>d.category)), subs:new Set(drops.map(d=>key(d.category,d.subcategory)))};
}
const pickedIn = c => [...state.subs].filter(k=>k.startsWith(c+" › "));
function typeOK(v){
  if(!state.cats.size) return true;
  return [...state.cats].some(c=>{ const p=pickedIn(c); return p.length ? p.some(k=>v.subs.has(k)) : v.cats.has(c); });
}
function dropTypeOK(d){
  if(!state.cats.size) return true;
  if(!state.cats.has(d.category)) return false;
  const p=pickedIn(d.category); return !p.length || p.includes(key(d.category,d.subcategory));
}

function renderChips(){
  const views=stores.map(view).filter(Boolean);
  const cCount=c=>views.filter(v=>v.cats.has(c)).length;
  const sCount=k=>views.filter(v=>v.subs.has(k)).length;
  $("catChips").innerHTML = CATS.map(c=>{const n=cCount(c);
    return `<button type="button" class="fd-chip${n?"":" zero"}" data-cat="${esc(c)}" aria-pressed="${state.cats.has(c)}">${esc(c)}<span class="n">${n}</span></button>`}).join("");
  const showCats=CATS.filter(c=>state.cats.has(c));
  $("subRow").hidden=!showCats.length;
  $("subChips").innerHTML = showCats.flatMap(c=>SUBS[c].map(s=>{const k=key(c,s),n=sCount(k);
    return `<button type="button" class="fd-chip small${n?"":" zero"}" data-sub="${esc(k)}" aria-pressed="${state.subs.has(k)}">${showCats.length>1?`<span class="cat">${esc(c)}</span>`:""}${esc(s)}<span class="n">${n}</span></button>`})).join("");
}
function stamp(n){
  const cls = n<=3?"f0":n<=7?"f1":"f2";
  const big = n===0?"today":n===1?"1 day":n+" days";
  return `<div class="fd-stamp ${cls}" title="Last shipment ${n===0?"today":big+" ago"}">shipped<strong>${big}</strong>${n===0?"":"ago"}</div>`;
}
function hl(text,q){ if(!q) return esc(text); const i=text.toLowerCase().indexOf(q); return i<0?esc(text):esc(text.slice(0,i))+"<mark>"+esc(text.slice(i,i+q.length))+"</mark>"+esc(text.slice(i+q.length)); }

function card(v,q){
  const {s,drops}=v;
  const lines=CATS.filter(c=>v.cats.has(c)).map(c=>{
    const subs=SUBS[c].filter(x=>v.subs.has(key(c,x)));
    return `<div class="fd-tline"><b>${esc(c)}</b><span class="tags">${subs.map(x=>`<span class="fd-tag${state.cats.size&&dropTypeOK({category:c,subcategory:x})?" hit":""}" data-cat="${esc(c)}">${esc(x)}</span>`).join("")}</span></div>`;
  }).join("");
  const strainHits = q ? [...new Set(drops.filter(d=>d.strain.toLowerCase().includes(q)&&dropTypeOK(d)).map(d=>d.strain))] : [];
  const byDate = [...new Set(drops.map(d=>d.shipped))].sort().reverse().map(date=>{
    const ds=drops.filter(d=>d.shipped===date);
    const groups=[]; CATS.forEach(c=>SUBS[c].forEach(x=>{const g=ds.filter(d=>d.category===c&&d.subcategory===x); if(g.length) groups.push([c,x,[...new Set(g.map(d=>d.strain))].sort()]);}));
    return `<div class="fd-drop"><h3>${esc(fmtDate(date))}</h3>${groups.map(([c,x,st])=>`<p><span class="fd-type${state.cats.size&&dropTypeOK({category:c,subcategory:x})?" hit":""}" data-cat="${esc(c)}">${esc(c)} ${esc(x)}:</span> ${st.map(t=>hl(t,q)).join(", ")}</p>`).join("")}</div>`;
  }).join("");
  const nStr=new Set(drops.map(d=>key(d.category,d.subcategory)+d.strain)).size;
  const maps="https://www.google.com/maps/search/?api=1&query="+encodeURIComponent(s.store+", "+(s.address?s.address+", ":"")+s.city+", WA"+(s.zip?" "+s.zip:""));
  return `<article class="fd-card">
    <div class="fd-top">
      <div style="min-width:0"><h2>${hl(s.store,q)}</h2><div class="fd-addr"><span>${s.address?esc(s.address)+", ":""}${hl(s.city,q)}</span>${v.mi!=null&&isFinite(v.mi)&&state.here?`<span class="fd-dist">${fmtMi(v.mi)}</span>`:""}</div></div>
      ${stamp(v.last)}
    </div>
    <div class="fd-actions">${s.phone?`<a class="fd-act" href="tel:${esc(s.phone.replace(/\D/g,""))}"><span class="ph">${esc(s.phone)}</span></a>`:""}<a class="fd-act" href="${maps}" target="_blank" rel="noopener">Directions</a>${s.website?`<a class="fd-act" href="${esc(s.website)}" target="_blank" rel="noopener">Website</a>`:""}</div>
    ${strainHits.length?`<div class="fd-strainhit">Got <b>${strainHits.map(esc).join(", ")}</b></div>`:""}
    <div class="fd-types">${lines}</div>
    <details><summary>${nStr} product${nStr===1?"":"s"} shipped</summary>${byDate}</details>
  </article>`;
}

function filterSummary(){
  return CATS.filter(c=>state.cats.has(c)).map(c=>{const p=pickedIn(c).map(k=>k.split(" › ")[1]); return p.length? c+" "+p.join("/") : c;}).join(" or ");
}
function results(){
  const q=state.q.trim().toLowerCase();
  let list=stores.map(view).filter(v=>v && typeOK(v));
  if(state.here){ list.forEach(v=>v.mi=isNaN(v.s.lat)?Infinity:miles(state.here,v.s)); if(state.radius) list=list.filter(v=>v.mi<=state.radius); }
  list=list.filter(v=>(!q ||
    v.s.store.toLowerCase().includes(q) || v.s.city.toLowerCase().includes(q) || v.s.address.toLowerCase().includes(q) || v.s.zip.startsWith(q) ||
    v.drops.some(d=>dropTypeOK(d) && d.strain.toLowerCase().includes(q))));
  return list;
}
function render(){
  const q=state.q.trim().toLowerCase();
  let list=results();
  const az=(a,b)=>a.s.store.localeCompare(b.s.store);
  list.sort(state.sort==="near"&&state.here?(a,b)=>a.mi-b.mi||a.last-b.last : state.sort==="az"?az : state.sort==="city"?(a,b)=>a.s.city.localeCompare(b.s.city)||az(a,b) : (a,b)=>a.last-b.last||az(a,b));

  const anyFilter=state.cats.size||state.q||state.here;
  $("count").innerHTML = `<b>${list.length}</b> ${list.length===1?"store":"stores"}${state.here&&state.radius?` within ${state.radius} mi of ${esc(state.here.label)}`:state.here?` near ${esc(state.here.label)}`:""} with shipments in the last ${state.days} days${state.cats.size?` · ${esc(filterSummary())}`:""}`;
  const cb=$("clearAll"); if(cb) cb.hidden=!anyFilter;
  $("asof").textContent = latest ? "Shipments through " + fmtDate(latest,{month:"short",day:"numeric",year:"numeric"}) : "";

  if(!list.length){
    $("grid").innerHTML = `<div class="fd-empty">No stores with matching shipments in the last ${state.days} days${state.here&&state.radius?` within ${state.radius} mi`:""}.${state.here&&state.radius&&state.radius<50?`<br><button class="fd-btn" type="button" data-widen>Search within ${state.radius<10?10:state.radius<25?25:50} mi</button>`:""}<br><button class="fd-btn" type="button" data-clear>Clear filters</button></div>`;
    return;
  }
  const shown=list.slice(0,state.shown);
  $("grid").innerHTML = shown.map(v=>card(v,q)).join("") +
    (list.length>shown.length?`<button class="fd-btn fd-more" type="button" data-more>Show ${Math.min(PAGE,list.length-shown.length)} more of ${list.length-shown.length}</button>`:"");
}
function sync(resetPage=true){
  if(resetPage) state.shown=PAGE;
  $("windowSeg").querySelectorAll("button").forEach(b=>b.setAttribute("aria-pressed", +b.dataset.days===state.days));
  if(state.sort==="near"&&!state.here) state.sort="fresh";
  $("sortSeg").querySelectorAll("button").forEach(b=>b.setAttribute("aria-pressed", b.dataset.sort===state.sort));
  $("sortSeg").querySelector('[data-sort="near"]').hidden=!state.here;
  $("radiusSeg").hidden=!state.here;
  $("radiusSeg").querySelectorAll("button").forEach(b=>b.setAttribute("aria-pressed", +b.dataset.mi===state.radius));
  try{ localStorage.setItem("product-locator-filters",JSON.stringify({days:state.days,sort:state.sort==="near"?"fresh":state.sort})); }catch(e){}
  renderChips(); render();
}
function clearAll(){ state.q=""; $("q").value=""; state.cats.clear(); state.subs.clear(); clearLoc(); sync(); }
function msg(html,err){ const m=$("locMsg"); m.innerHTML=html; m.className="fd-locmsg"+(err?" err":""); }
function clearLoc(){ state.here=null; $("zip").value=""; msg(""); }
function setHere(here){
  state.here=here; state.sort="near";
  let note="";
  if(state.radius && !results().length){
    const start=state.radius;
    for(const r of [10,25,50,0]){ if(r && r<=start) continue; state.radius=r; if(results().length) break; }
    note = state.radius ? ` Nothing within ${start} mi, so we widened to ${state.radius} mi.` : ` Nothing within 50 mi, so we're showing all stores by distance.`;
  }
  msg(`Showing stores near <b>${esc(here.label)}</b>.${note} <button type="button" class="fd-linkbtn" data-loc-clear>Clear location</button>`);
  sync();
}
function useZip(){
  const z=$("zip").value.trim();
  if(!/^\d{5}$/.test(z)){ msg("Enter a 5-digit ZIP code.",true); return; }
  const c=ZIPS[z];
  if(!c){ msg(`We don't have ZIP ${esc(z)} on file. Try a nearby Washington ZIP.`,true); return; }
  setHere({lat:c[0],lng:c[1],label:z});
}

$("locForm").addEventListener("submit",e=>{e.preventDefault(); useZip();});
$("zip").addEventListener("input",e=>{ e.target.value=e.target.value.replace(/\D/g,"").slice(0,5); if(e.target.value.length===5) useZip(); else if(!e.target.value && state.here){ clearLoc(); sync(); } });
$("zip").addEventListener("keydown",e=>{ if(e.key==="Enter"){ e.preventDefault(); useZip(); } });
$("nearMe").addEventListener("click",()=>{
  const b=$("nearMe");
  if(!navigator.geolocation){ msg("Your browser can't share your location. Enter a ZIP code instead.",true); return; }
  b.setAttribute("aria-busy","true"); msg("Finding your location…");
  navigator.geolocation.getCurrentPosition(
    p=>{ b.removeAttribute("aria-busy"); $("zip").value=""; setHere({lat:p.coords.latitude,lng:p.coords.longitude,label:"your location"}); },
    ()=>{ b.removeAttribute("aria-busy"); msg("We couldn't get your location. Enter a ZIP code instead.",true); },
    {enableHighAccuracy:false,timeout:10000,maximumAge:600000});
});
$("radiusSeg").addEventListener("click",e=>{const b=e.target.closest("button"); if(!b) return; state.radius=+b.dataset.mi; sync();});
$("q").addEventListener("input",e=>{suggest(e.target.value); state.q=e.target.value; state.shown=PAGE; render();});
$("catChips").insertAdjacentHTML("afterend",'<button type="button" class="fd-clearall" data-fd="clearAll" data-clear hidden><span aria-hidden="true">✕</span> Clear filters</button>');
$("catChips").addEventListener("click",e=>{const b=e.target.closest(".fd-chip"); if(!b) return; const c=b.dataset.cat;
  if(state.cats.has(c)){ state.cats.delete(c); pickedIn(c).forEach(k=>state.subs.delete(k)); } else state.cats.add(c);
  sync();});
$("subChips").addEventListener("click",e=>{const b=e.target.closest(".fd-chip"); if(!b) return; const k=b.dataset.sub; state.subs.has(k)?state.subs.delete(k):state.subs.add(k); sync();});
$("optToggle").addEventListener("click",e=>{const open=$("controls").classList.toggle("opts-open"); e.currentTarget.setAttribute("aria-expanded",open);});
$("windowSeg").addEventListener("click",e=>{const b=e.target.closest("button"); if(!b) return; state.days=+b.dataset.days; sync();});
$("sortSeg").addEventListener("click",e=>{const b=e.target.closest("button"); if(!b) return; state.sort=b.dataset.sort; sync();});
root.addEventListener("click",e=>{
  if(e.target.closest("[data-clear]")) clearAll();
  if(e.target.closest("[data-loc-clear]")){ clearLoc(); sync(); }
  if(e.target.closest("[data-widen]")){ state.radius=state.radius<10?10:state.radius<25?25:50; sync(); }
  if(e.target.closest("[data-more]")){ state.shown+=PAGE; render(); }
});

$("srcBadge").textContent = `${stores.length} stores · last 14 days`; $("srcBadge").hidden=false;
const strains=[...new Set(stores.flatMap(s=>s.drops.map(d=>d.strain)))].filter(Boolean).sort();
function suggest(v){
  const q=v.trim().toLowerCase();
  const hits = q.length<2 ? [] : strains.filter(s=>s.toLowerCase().includes(q) && s.toLowerCase()!==q).sort((a,b)=>a.toLowerCase().indexOf(q)-b.toLowerCase().indexOf(q)).slice(0,8);
  $("qlist").innerHTML = hits.map(s=>`<option value="${esc(s)}">`).join("");
}

sync();
}

async function boot(root){
  if(root.dataset.fdReady) return; root.dataset.fdReady="1";
  const count=root.querySelector('[data-fd="count"]');
  try{
    const [csv, zips] = await Promise.all([
      fetch(root.dataset.csvUrl,{cache:"no-cache"}).then(r=>{ if(!r.ok) throw new Error("csv "+r.status); return r.text(); }),
      fetch(root.dataset.zipsUrl).then(r=>r.ok?r.json():{}).catch(()=>({}))
    ]);
    init(root, csv, zips);
  }catch(e){
    console.error("Product Locator:", e);
    if(count) count.textContent="Store list isn't available right now. Please check back soon.";
  }
}
function start(){ document.querySelectorAll("[data-product-locator]").forEach(boot); }
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",start); else start();
document.addEventListener("shopify:section:load",start);
})();
